// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    add_own_options: 'Añade tus propias opciones',
    allActivities: 'Todos los Tipos de Actividad (Tarea, Problema, Solicitud)',
    AllActivities_group_title: 'Todos los campos de Tipos de Actividad (Tarea, Problema, Solicitud)',
    customer: 'Cliente',
    Customer_group_title: 'Campos de cliente',
    default_field_name: 'Nuevo campo',
    delete_field_title: 'Eliminar campo {0}?',
    expense: 'Gasto',
    Expense_group_title: 'Campos de gastos',
    issue: 'Asunto',
    Issue_group_title: 'Campos de emisión',
    limitReachedMessage: 'Lo sentimos, ha alcanzado el número máximo de campos personalizados del tipo elegido que puede agregar.',
    msg_deleteUsedValue: 'Este valor se utiliza en {0} {1}',
    msg_entities_portfolioRemoved: 'Este campo ya no estará disponible para las entidades incluidas en las carteras excluidas',
    msg_lead_to: 'Este cambio dará como resultado lo siguiente:',
    msg_restrictionsAdded: 'Este campo personalizado estará restringido por cartera.',
    msg_restrictionsRemoved: 'Este campo personalizado ya no estará restringido por cartera.',
    msg_unportfolioedOff: 'Este campo personalizado no estará disponible para proyectos que no estén incluidos en portafolios.',
    msg_valueRemoved: 'Los elementos de la lista excluidos de este campo personalizado se eliminarán.',
    portfolio: 'Portafolio',
    Portfolio_group_title: 'Campos de portafolio',
    project: 'Proyecto',
    Project_group_title: 'Campos de proyecto',
    request: 'Solicitud',
    Request_group_title: 'Campos de solicitud',
    select_from: 'Seleccionar campo personalizado',
    task: 'Tarea',
    Task_group_title: 'Campos de tarea',
    text_add: 'Agregar',
    text_add_new_item: 'Agregue un nuevo elemento o use Ctrl + V para pegar una lista de elementos',
    text_add_portfolio: 'Añadir portafolio',
    text_addDescription: 'Añadir descripción',
    text_all_objects: 'Todos los objetos',
    text_available_in: 'Portafolios para el campo:',
    text_create_new_field: 'Crear un nuevo campo',
    text_currentIdentity: 'Empezar desde:',
    text_custom_field_for: 'Campo para',
    text_delete: 'Eliminar campo',
    text_delete_permanently: 'Eliminar permanente',
    text_deleteValue: 'Eliminar valor',
    text_edit: 'Editar campo',
    text_empty_page_part1: 'Necesita más flexibilidad para realizar un seguimiento de sus datos y elaborar informes al respecto?',
    text_empty_page_part2: 'Agregue sus propios campos para proyectos, tareas, usuarios y más...',
    text_error_title: 'La operación no se pudo completar.',
    text_fieldName: 'Nombre de campo',
    text_fieldType: 'Tipo de campo:',
    text_filter: 'Campos personalizados para',
    text_include_in_unportfolioed_projects: 'Muéstrelo también para proyectos no incluidos en portafolios',
    text_isIdentity: 'Incremento automático',
    text_isNumeric: 'No mostrar decimales',
    text_isRequired: 'Es obligatorio',
    text_place_plural: '1#lugar#lugares',
    text_remainingValuesTemplate: 'mostrar {0} elementos ocultos en la parte superior de la lista',
    text_remove: 'Eliminar',
    text_restricted_by_portfolio: 'Límite por portafolio',
    text_set_restrictions: 'Mostrar este campo solo para proyectos incluidos en portafolios seleccionados',
    timeEntry: 'De la entrada de tiempo',
    TimeEntry_group_title: 'Campos de Entrada de hora',
    use_cfs_options: 'Usar un campo personalizado como fuente de opciones',
    use_own_options: 'Usa tus propias opciones',
    user: 'Usuario',
    User_group_title: 'Campos de usuario',
};
